import React from 'react';
import CheckBox from '../Core/Inputs/CheckBox';
import SelectableBox from '../Core/SelectableBox';

const EmployeeItem = ({
    employee,
    selectedEmployees,
    adminEmployees,
    handleEmployeeSelection,
    handleAdminSelection,
    isCreateProject = false,
    text,
}) => {
    let isAdmin = false;
    const isSelected = selectedEmployees.some(e => e?._id === employee?._id);
    if (isCreateProject) {
        isAdmin = adminEmployees.some(e => e?._id === employee?._id);
    }

    return (
        <SelectableBox
            key={employee?._id}
            className='flex flex-column w-100'
            showLightColors
        >
            <CheckBox
                label={`${employee?.firstName} ${employee?.lastName} (${employee?.email})`}
                checked={isSelected}
                onChange={() => handleEmployeeSelection(employee)}
                showLightColors
            />
            {(isSelected && isCreateProject) && (
                <CheckBox
                    className='mt-sm'
                    checked={isAdmin}
                    onChange={() => handleAdminSelection(employee)}
                    label={text?.projects?.create?.admin}
                    showLightColors
                />
            )}
        </SelectableBox>
    );
};

export default EmployeeItem;
